import { Component, HostListener } from '@angular/core';
import { AuditLogService } from './services/audit-log/audit-log.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  unsavedCheck: (() => boolean) | null = null;

  registerUnsavedCheck(fn: () => boolean) {
    this.unsavedCheck = fn;
  }
  
  clearUnsavedCheck() {
    this.unsavedCheck = null;
  }

  /**
   *
   */
  constructor(private readonly auditLogService: AuditLogService) {
    
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent) {
    // log page exit
    this.auditLogService.logCloseApplication();
    if (this.unsavedCheck && !this.unsavedCheck()) {
      $event.preventDefault();
      $event.returnValue = ''; // triggers browser dialog
    }
  }
}
